import React, { useMemo } from "react"

import classNames from "classnames"

import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

import "./styles/_validity-indicator.scss"

interface ValidityIndicatorProps {
  isValid?: boolean
  isLoading?: boolean
  title?: string
  size?: IconSize
}

export const ValidityIndicator = React.memo(
  ({ isValid, isLoading, title, size }: ValidityIndicatorProps) => {
    const inner = useMemo(() => {
      if (isLoading) {
        return (
          <Skeleton
            fill
            className={classNames(
              "icon",
              "validity-indicator",
              "validity-indicator--loading",
              size
            )}
          />
        )
      }
      if (isValid === undefined) {
        return (
          <Icon
            name={IconName.QUESTION}
            className="color-gray-300"
            data-testid="valid-undetermined-icon"
            size={size}
          />
        )
      }
      if (isValid) {
        return (
          <Icon
            name={IconName.CHECK_CIRCLE}
            className="color-success"
            data-testid="valid-icon"
            size={size}
          />
        )
      }
      return (
        <Icon
          name={IconName.CLOSE_CIRCLE}
          className="color-danger"
          data-testid="invalid-icon"
          size={size}
        />
      )
    }, [isValid, isLoading, size])

    return (
      <div
        className="validity-indicator"
        title={title}
        data-testid="validity-indicator"
      >
        {inner}
      </div>
    )
  }
)
